import {
  View,
  StyleSheet,
  ScrollView,
  Platform,
  StatusBar,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  fetchAllExperience,
  setInboxUser,
} from "../../../redux/experience/experienceSlice";
import { RootState, dispatch, useSelector } from "../../../redux/store";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import AllExperienceList from "./components/cardComponents/AllExperienceList";
import Experiencelist from "./components/cardComponents/Experiencelist";
import dimensions from "../../../globalStyles/dimensions";
import LocationComponent from "./components/LocationComponent";
import TopSection from "./components/TopSection";
import ImageContainer from "./components/ImageContainer";
import AllExperienceLoader from "./components/loaders/AllExperienceLoader";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ExperienceIcons from "../../../assets/Icons/ExperienceIcons";
import InitialEmptyScreen from "./InitialEmptyScreen";

export default function AllExperience({ route }: { route: any }) {

  const {
    experiences: { data: experiences, isLoading: isLoading, error: error }
  } = useSelector((state: RootState) => state.experience);

  const {location} = useSelector((state: RootState)=> state.user)

  const [receiverUserInfo, setReceiverUserInfo] = useState({
    receiverName: "",
    receiverChatRoomId: "",
    receiverUserId: "",
  });

  const insets = useSafeAreaInsets();

  const [globalerror, setGlobalError] = useState(true);
  const toggleError = () => {
    setGlobalError(!globalerror)
  }

  useEffect(() => {
    if (route?.params?.currentUser) {
      setReceiverUserInfo((prevState) => ({
        ...prevState,
        receiverName: route.params.currentUser.firstName,
        receiverUserId: route.params.currentUser._id,
        receiverChatRoomId: route.params.chatRoomId,
      }));
    }
  }, [route.params]);

  useEffect(() => {
    if (receiverUserInfo) {
      dispatch(setInboxUser(receiverUserInfo));
    }
  }, [receiverUserInfo]);

  useEffect(() => {
    dispatch(fetchAllExperience());
  }, []);


  
  if (isLoading || !experiences) {
    return <AllExperienceLoader />;
  }

  else if(!isLoading && !experiences){
    return(
      <InitialEmptyScreen/>
    )
  }

  return (
    <>
      <StatusBar
        translucent
        backgroundColor={"transparent"}
        barStyle={"dark-content"}
      />
      {/* {
        globalerror && (
          <ErrorModal toggleModal={toggleError} />
        )  
      } */}
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          backgroundColor: "#fff",
          paddingTop: Platform.OS === "ios" ? insets.top / 2 : Platform.OS === 'android' ? insets.top : insets.top * 1.5,
        }}
      >
        <View
          style={{
            paddingHorizontal:
              Platform.OS === "ios" || Platform.OS === "android"
                ? dimensions.paddingHorizontal
                : 20,
          }}
        >
          <TopSection isIcon={route?.params?.currentUser} />
          {
            Platform.OS != 'web' &&  <LocationComponent location={location} />
          }
          {experiences && (
            <ImageContainer data={experiences[2]} isLoading={isLoading} />
          )}
        </View>
        <View
          style={[
            styles.mainContainer,
            {
              marginTop: 12,
             
            },
          ]}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              left: -20,
            }}
          >
            <ExperienceIcons.WayLine />
          </View>
          <CustomComponent.TextView
            title="Experiences you might like"
            textStyle={[
              GlobalStyles.title1,
              {
                fontFamily: "EBGaramondBold",
                fontSize: 26,
                color: "#3F3F3F",
                lineHeight: 37,
                letterSpacing: -0.5,
              },
            ]}
          />
        </View>

        <Experiencelist
          data={experiences}
          horizontal
          contentContainerStyle={{
            gap: 10,
            marginTop: 0,
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
        />

        <View style={styles.mainContainer}>
        <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              left: -20,
              marginTop: 15,
              marginBottom: 10,
            }}
          >
            <ExperienceIcons.WayLine />
          </View>
          {/* <CustomComponent.TextView
            title="Popular experiences"
            textStyle={[
              GlobalStyles.title1,
              {
                fontFamily: "EBGaramondBold",
                fontSize: 26,
                color: "#3F3F3F",
                lineHeight: 37,
                letterSpacing: -0.5,
              },
            ]}
          /> */}
        </View>

        {/* <Experiencelist
          data={experiences}
          horizontal
          contentContainerStyle={{
            gap: 10,
            marginTop: 0,
            paddingHorizontal: dimensions.paddingHorizontal,
          }}
          scrollfunction={() => {}}
        /> */}

        <View style={styles.mainContainer}>
        {/* <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              left: -20,
              marginTop: 15,
              marginBottom: 10,
            }}
          >
            <ExperienceIcons.WayLine />
          </View> */}
          <CustomComponent.TextView
            title="All experiences"
            textStyle={[
              GlobalStyles.title1,
              {
                fontFamily: "EBGaramondBold",
                fontSize: 26,
                color: "#3F3F3F",
                lineHeight: 37,
                letterSpacing: -0.5,
              },
            ]}
          />
        </View>
        <AllExperienceList data={experiences} />
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    // paddingVertical: dimensions.paddingVertical*2,
    // paddingHorizontal:
    //   Platform.OS === "ios" || Platform.OS === "android"
    //     ? dimensions.paddingHorizontal
    //     : 20,
    paddingLeft:
      Platform.OS === "ios" || Platform.OS === "android"
        ? dimensions.paddingHorizontal
        : 20,
    paddingTop: 10,
  },
});
